import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';

import { RouterLink } from '@angular/router';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { responsiveBreakpoints } from '../../utils/const/responsive-breakpoints';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../core/auth/auth.service';
import { UpperCasePipe } from '@angular/common';
import { CONFIG } from '../../../core/config/config.token';
import { UserClaims } from '@okta/okta-auth-js';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatIcon,
    TranslocoPipe,
    UpperCasePipe,
  ],
})
export class HeaderComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly sidenavService = inject(SidenavService);
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly config = inject(CONFIG);

  title = '';
  sidenavIsOpen = true;
  showSidenav = true;
  userInfo: UserClaims | null = null;
  isAuthSuccess = false;
  protected readonly showDebugPanel = this.config.showDebugPanel;
  protected readonly envName = this.config.env;

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.authService.authReady$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((ready: boolean) => {
        this.isAuthSuccess = ready;
        this.checkSidenavVisibility();
      });

    // Subscribes to userInfo changes from AuthenticatedService.
    this.authService.userInfo$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((userInfo) => {
      this.userInfo = userInfo;
    });
  }

  ngOnInit() {
    this.breakpointObserver
      .observe([
        responsiveBreakpoints.small,
        responsiveBreakpoints.medium,
        responsiveBreakpoints.large,
      ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state) => {
        const isSmall = state.breakpoints[responsiveBreakpoints.small];
        const currentOpen = this.sidenavService.getIsSidenavOpen();
        if (currentOpen === isSmall) {
          this.sidenavService.setSidenavOpen(!isSmall);
          this.sidenavIsOpen = !isSmall;
        }
      });
  }

  logout() {
    // Initiates the logout process.
    this.authService.logout();
  }

  checkSidenavVisibility() {
    const currentPath = globalThis.location.pathname;
    const noSidenavRoutes = ['/access-error'];

    this.showSidenav = !noSidenavRoutes.includes(currentPath) && this.isAuthSuccess;
  }

  toggleSidenav() {
    // Toggles the sidenav's open/close state.
    this.sidenavService.toggleMenu();
    this.sidenavIsOpen = !this.sidenavIsOpen;
  }
}
